import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../shared/services/data.service';
import { ValidationMessage } from '../shared/constant';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {
  disclaimerText: string = '';
  constructor(private router: Router,
    public dataService: DataService) {


  }
  ngOnInit() {
    this.disclaimerText = ValidationMessage.disclaimerText;
  }
  navigateByUrl() {
    localStorage.setItem("IsTermsAccepted", "true");
    this.dataService.IsTermsAccepted = true;
    this.router.navigateByUrl('/group/0');
  }
  navigrationBack() {
    window.location.href = this.dataService.redirectToQuoteLiteUrl();
  }

}
